export default "__VITE_ASSET__CQLSA$qC__"